module.exports = __webpack_public_path__ + "img/tile-ita1.02c0bb4f.jpg";